import React, { useState } from 'react'
import styles from './style.module.scss'
import Icons from '../Icons'

export const Card = ({title, icon, description, expanded, colsize, required, help, children, defaultShowValue}) => {
  if ( !title )
    throw("Error: Card title is null. (at src/_components/Card/index.jsx:3)")

  let IconComponent = {}
  if ( icon ) IconComponent = Icons[icon]

  const [ show, setShow ] = useState(defaultShowValue === false ? defaultShowValue : true)
  const handleChange = () => setShow(!show)

  return (
    <section className={`${!colsize ? "col" : `col-${colsize}`} ${styles.card} ${styles['card--white']}`}>
      <header>
        <div className={description ? styles['card--has-description'] : show ? styles['card--is-showing'] : ""}>
          <h2>
            {IconComponent ? <IconComponent /> : ""}
            {title}
          </h2>
          { help ? <span className="help" data-help={help}>?</span> : "" }
          { required ? <span className={styles.required}>Obrigatório</span> : "" }
        </div>
        {
          description &&
            <p dangerouslySetInnerHTML={{__html: description}} className={styles.description}></p>
        }

        {
          !expanded && <button
          type="button"
          className={`${styles.expand} ${show ? styles.active : ""}`}
          onClick={handleChange} />
        }
       
      </header>

      <div className={`${styles.body} ${show ? styles.active : ""}`}>
        {children}
      </div>
    </section>
  )
}